import styled, { css } from 'styled-components';
import { aboveMobile, aboveTablet, desktop, largeDesktop } from '../../const/styles';
import _LoopIcon from '../Icons/LoopIcon';

interface SectionProps {
	readonly isEnabled: boolean;
}
export const StyledSection = styled.div<SectionProps>`
	background-color: var(--off-background);
	color: var(--foreground);
	border-radius: 7px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
	padding: 9px;
	margin: 52px 4px 40px 12px;
	position: relative;
	@media only screen and (min-width: ${aboveMobile}) {
		grid-template-columns: repeat(3, 1fr);
	}
	@media only screen and (min-width: ${aboveTablet}) {
		grid-template-columns: repeat(4, 1fr);
	}
	@media only screen and (min-width: ${desktop}) {
		grid-template-columns: repeat(5, 1fr);
	}
	@media only screen and (min-width: ${largeDesktop}) {
		grid-template-columns: repeat(6, 1fr);
	}
	${({ isEnabled }) =>
		!isEnabled &&
		css`
			opacity: 0.5;
		`}
`;

export const StyledSectionHeader = styled.div`
	position: absolute;
	top: -35px;
	left: 50%;
	transform: translateX(-50%);
	width: calc(100% - 24px);
	align-items: end;
	display: flex;
	justify-content: space-between;
`;

const SectionHeaderPart = css`
	cursor: pointer;
	border: none;
	color: var(--foreground);
	background: var(--off-background);
	border-radius: 7px;
	padding: 10px 34px;
	display: flex;
	justify-content: center;
	align-items: center;
	justify-self: center;
	font-weight: bold;
	font-size: 14px;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	white-space: nowrap;
`;
export const SectionHeaderName = styled.div`
	${SectionHeaderPart}
	padding: 10px 15px;

	span {
		max-width: 180px;
		overflow: hidden;
		text-overflow: ellipsis;
		font-size: 13px;
	}
`;

export const SectionRepeatCount = styled.div`
	display: flex;
	position: absolute;
	bottom: -32px;
	left: 13px;
`;

export const SectionSwitch = styled.div`
	${SectionHeaderPart}
	padding: 6px 8px 2px;
	justify-self: end;
`;

interface RepeatIndicatorProps {
	readonly active: boolean;
}
export const RepeatIndicator = styled.div<RepeatIndicatorProps>`
	width: 25px;
	height: 32px;
	border-radius: 7px;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	background: var(--off-background);
	${({ active }) =>
		!active &&
		css`
			box-shadow: var(--tab-inner-shadow);
		`}
	margin: 0 2px;
	position: relative;
	span {
		color: ${({ active }) => (active ? 'var(--foreground)' : 'var(--border-color)')};
		font-size: 12px;
		font-weight: bold;
		position: absolute;
		line-height: 0;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
	}
`;

interface ProgressLineProps {
	readonly active: boolean;
	readonly progress: number;
	readonly sectionLengthInSeconds: number;
}
export const StyledProgressLine = styled.div<ProgressLineProps>`
	opacity: ${({ active }) => (active ? 1 : 0)};
	height: 2px;
	border-radius: 3px;
	width: calc(${({ active, progress }) => (active ? progress : 0)}% - 20px);
	left: 10px;
	background: var(--foreground-gradient);
	position: absolute;
	bottom: 4px;
	transition: width ${({ sectionLengthInSeconds }) => sectionLengthInSeconds}s linear;
`;

export const LoopIcon = styled(_LoopIcon)`
	margin-right: 6px;
`;
